"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservationHistory = void 0;
const ObjectHistory_1 = require("./ObjectHistory");
const HistoryStore_1 = require("./HistoryStore");
const typeName = 'ObservationHistory';
class ObservationHistory extends ObjectHistory_1.ObjectHistory {
    constructor(ob) {
        super({
            ...ob,
            type: typeName,
        });
        this.observedHistory = new HistoryStore_1.HistoryStore(ob.observedHistory ?? {
            systemProperties: {
                autoTrim: false,
                maxAgeMS: undefined,
                maxLength: undefined,
            },
        });
        this.googleSheet = ob.googleSheet;
    }
}
exports.ObservationHistory = ObservationHistory;
